<nouislider #slider (end)="onUpdate()" (update)="onUpdateValues($event)" [connect]="true" [min]="0" [max]="1500"
            [(ngModel)]="range"></nouislider>
<div class="values">
  <div class="value-container">
    <span>{{'pages.products.placeHolders.min' | translate}}</span>
    <app-input [value]="value1" (inputChange)="minValueInputChange($event)" (focus)="shouldEmit = true"
               (blur)="shouldEmit = false"
               [isDisabled]="true"></app-input>
  </div>
  <div class="value-container">
    <span>{{'pages.products.placeHolders.max' | translate}}</span>
    <app-input [value]="value2" (inputChange)="maxValueInputChange($event)" (focus)="shouldEmit = true"
               (blur)="shouldEmit = false"
               [isDisabled]="true"></app-input>
  </div>
</div>
